/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

import * as Types from "../../generated/types";

export type ContactFieldMinDetailsFragment = {
  __typename: "ContactField";
  uuid: string | null;
  fieldName: string | null;
  fieldDisplay: string | null;
};

export type NumberMinFragmentFragment = {
  __typename: "Number";
  uuid: string | null;
  vname: string | null;
  fromAddr: string | null;
  profilePicture: string | null;
  numberType: Types.NumberType | null;
  backendType: Types.BackendType | null;
  numberCode: string | null;
  numberRoute: { __typename: "Number"; uuid: string | null; fromAddr: string | null } | null;
};

export const ContactFieldMinDetailsFragmentDoc = gql`
  fragment ContactFieldMinDetails on ContactField {
    uuid
    fieldName
    fieldDisplay
  }
`;
export const NumberMinFragmentFragmentDoc = gql`
  fragment NumberMinFragment_ on Number {
    uuid
    vname
    fromAddr
    profilePicture
    numberType
    backendType
    numberCode
    numberRoute {
      uuid
      fromAddr
    }
  }
`;
